import React, { useState, useContext, useEffect } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import OverviewTab from "./OverviewTab";
import ViolationsTab from "./ViolationsTab";
import WorkOrdersTab from "./WorkOrdersTab";
import ArchitecturalRequestsTab from "./ArchitecturalRequestsTab";
import Billing from "./Billing";
import { PermissionsContext } from "../../utils/PermissionsContext";
import { ModulesContext, isModuleActive } from "../../utils/ModulesContext";

const ReportsPage = () => {
  const permissionsCtx = useContext(PermissionsContext);
  const { modules } = useContext(ModulesContext);

  const hasPermission =
    typeof permissionsCtx === "function"
      ? permissionsCtx
      : (perm) => Array.isArray(permissionsCtx) && permissionsCtx.includes(perm);

  const tabConfig = [
    { label: "Overview", component: <OverviewTab />, permission: null },
    {
      label: "Violations",
      component: <ViolationsTab />,
      permission: "view_violation_reports",
      moduleId: 2,
    },
    {
      label: "Work Orders",
      component: <WorkOrdersTab />,
      permission: "view_work_order_reports",
      moduleId: 1,
    },
    {
      label: "Architectural Requests",
      component: <ArchitecturalRequestsTab />,
      permission: "view_architectural_reports",
      moduleId: 3,
    },
    {
      label: "Billing",
      component: <Billing />,
      permission: "view_billing_reports",
    },
  ];

  const visibleTabs = tabConfig.filter(
    ({ permission, moduleId }) =>
      (!permission || hasPermission(permission)) &&
      isModuleActive(modules, moduleId)
  );

  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (_event, newValue) => setCurrentTab(newValue);

  useEffect(() => {
    if (currentTab > visibleTabs.length - 1) {
      setCurrentTab(0);
    }
  }, [visibleTabs.length, currentTab]);

  if (visibleTabs.length === 0) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: "18px",
          border: "1px solid rgba(47,99,173,0.08)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          backgroundColor: "rgba(255,255,255,0.96)",
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#223142", mb: 0.5 }}
        >
          Reports
        </Typography>
        <Typography sx={{ color: "#6b778c" }}>
          You do not have permission to view any reports.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 3 }}>
      
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          border: "1px solid rgba(47,99,173,0.08)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          backgroundColor: "rgba(255,255,255,0.96)",
          overflow: "hidden",
          mb: 3,
        }}
      >
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            pt: 2.5,
            pb: 1.5,
            borderBottom: "1px solid rgba(47,99,173,0.08)",
            backgroundColor: "rgba(47,99,173,0.02)",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#223142",
              mb: 0.5,
            }}
          >
            Reports & Analytics
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#6b778c",
              mb: 2,
            }}
          >
            Switch between report categories.
          </Typography>

          <Tabs
            value={currentTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="Reports Tabs"
            sx={{
              minHeight: "auto",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "10px",
                minHeight: 42,
                color: "#5f6b7a",
                mr: 1,
                px: 2,
              },
              "& .Mui-selected": {
                color: "#2f63ad !important",
                backgroundColor: "rgba(47,99,173,0.08)",
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {visibleTabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
        </Box>
      </Paper>

      <Box sx={{ width: "100%" }}>
        {visibleTabs[currentTab]?.component}
      </Box>
    </Box>
  );
};

export default ReportsPage;